<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>员工管理</el-breadcrumb-item>
            <el-breadcrumb-item>员工列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <!-- 查询框 -->
            <el-row :gutter="24">
                <el-col :span="5">
                    <el-input
                        v-model="queryInfo.realname"
                        placeholder="请输入手机号、姓名"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="5">
                  <el-select v-model="queryInfo.storeId" placeholder="请选择店铺">
                    <el-option
                      v-for="item in storeList"
                      :key="item.id"
                      :label="item.storeName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5">
                  <el-select v-model="queryInfo.postion" placeholder="请选择角色">
                    <el-option
                      v-for="item in postionList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="7">
                    <el-button @click="handleSearch" type="primary">搜索</el-button>
                    <el-button @click="handleAdd" type="success">新增</el-button>
                    <el-button @click="handleClear" type="warning">清空</el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList"  stripe>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="员工姓名" prop="realname"></el-table-column>
                <el-table-column label="手机号码"  prop="phone"></el-table-column>
                <el-table-column label="店铺"  prop="storeId_dictText"></el-table-column>
                <el-table-column label="系统角色"  prop="postion">
                  <template slot-scope="scope">
                    <span v-if="scope.row.postion == 0">校长</span>
                    <span v-if="scope.row.postion == 1">学管师</span>
                    <span v-if="scope.row.postion == 2">教师</span>
                    <span v-if="scope.row.postion == 8">管理员</span>
                  </template>
                </el-table-column>
                <el-table-column label="登录账号"  prop="username"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button title="更改登录账号及登录密码" @click="handleUpdatePwd(scope.row)" type="text" style="color:#13C2C2">更改账号密码</el-button>
                        <el-button @click="handleEdit(scope.row)" type="text" style="color:#FF9F00">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" style="color:#F53F3F">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 页数码 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNo"
                :page-sizes="[10, 15, 20, 25, 30, 35]"
                :page-size="queryInfo.pageSize"
                :total="total"
                background
            ></el-pagination>
        </el-card>
        <el-dialog
            :title="editData.id?'编辑员工信息':'添加员工'"
            :visible.sync="addEditModalShow"
            :close-on-click-modal="false"
            width="40%"
        >
            <el-form :rules="rules" ref="fromData" :model="fromData" :label-position="'right'" label-width="90px">
                <el-form-item label="员工姓名" prop="realname">
                    <el-input v-model="fromData.realname" style="width: 84%"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="fromData.phone" style="width: 84%"></el-input>
                </el-form-item>
                <el-form-item v-if="!editData.id" label="登录账号" prop="username">
                    <el-input v-model="fromData.username" style="width: 84%"></el-input>
                </el-form-item>
                <el-form-item label="店铺" prop="storeId">
                    <el-select v-model="fromData.storeId" style="width: 84%" placeholder="请选择">
                        <el-option
                            v-for="item in storeList"
                            :key="item.id"
                            :label="item.storeName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="员工岗位" prop="postion">
                    <el-select v-model="fromData.postion" style="width: 84%" placeholder="请选择">
                        <el-option
                            v-for="item in postionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位级别" prop="postionLevel">
                    <el-select v-model="fromData.postionLevel" style="width: 84%" placeholder="请选择">
                        <el-option
                            v-for="item in postionLevelList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="!editData.id">
                    <span class="tips"><i class="el-icon-warning-outline icons"></i> 初始登录密码默认手机号后六位</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addEditModalShow = false">取 消</el-button>
                <el-button type="primary" @click="handleOk()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="'修改密码'"
            :visible.sync="pwdModalShow"
            :close-on-click-modal="false"
            width="40%"
        >
            <el-form :label-position="'right'" label-width="90px">
                <el-form-item label="员工姓名" prop="realname">
                    <el-input readonly v-model="fromData2.realname" style="width: 83%"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="username">
                    <el-input v-model="fromData2.username" style="width: 83%"></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="fromData2.password" style="width: 83%"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input v-model="fromData2.password2" style="width: 83%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pwdModalShow = false">取 消</el-button>
                <el-button type="primary" @click="handleChangePwd()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                dataList: [],
                // 排序方式(1价格升序、2价格降序、3次数升序、4次数降序，5新增时间升序，6新增时间降序（默认）
                queryInfo: {
                    realname:'',
                    username: '',
                    storeId: '',
                    postion: '',
                    pageSize: 10,
                    pageNo: 1,
                },
                total: 0,
                selectList: [],
                fromData:{
                    id:'',
                    realname:'',
                    phone:'',
                    storeId:0,
                    postion:'',  //岗位
                    username:'',
                    postionLevel:''
                },
                storeList: [],
                postionList: [
                    { label:'校长',value: 0 },
                    { label:'学管师',value: 1 },
                    { label:'教师',value: 2 }
                ],
                postionLevelList:[
                    { label:'名师2',value: 1 },
                    { label:'名师1',value: 2 },
                    { label:'优秀2',value: 3 },
                    { label:'优秀1',value: 4 },
                    { label:'骨干2',value: 5 },
                    { label:'骨干1',value: 6 },
                    { label:'全职',value: 7 }
                ],
                rules: {
                  phone: [
                    { required: true, message: '请填写手机号', trigger: 'blur' }
                  ],
                  realname:[
                    { required: true, message: '请填写员工姓名', trigger: 'blur' }
                  ],
                  username:[
                    { required: true, message: '请填写登录账号', trigger: 'blur' }
                  ],
                  postion:[
                    { required: true, message: '请选择岗位', trigger: 'blur' }
                  ],
                },
                addEditModalShow: false,
                editData:{},
                pwdModalShow: false,
                fromData2:{
                    password: '',
                    password2: '',
                    userId: '',
                    username: '',
                    realname:'',
                }
            }
        },
        mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                await this.$http.post("/ea/sys/user/list",this.queryInfo).then((res) => {
                    let data = res.data;
                    if(data && data.code == 0){
                        this.dataList = data.result.records;
                        this.total = data.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: data.message,
                            type:'error'
                        });
                    }
                })
                await this.$http.post("/ea/student/store/queryStoreList").then((res) => {
                    let data = res.data;
                    if(data && data.code == 200){
                        this.storeList = data.result;
                    }
                })
            },
            handleSearch() {
                this.initData();
            },
            handleAdd() {
                this.editData = {};
                this.fromData={
                    id:'',
                    realname:'',
                    phone:'',
                    postion:'',  //岗位
                    username:'',
                    postionLevel:''
                },
                this.addEditModalShow = true;
            },
            handleClear() {
                this.queryInfo.realname = '';
                this.queryInfo.username = null;
                this.queryInfo.postion = null;
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleEdit(record) {
                this.editData = record;
                this.fromData = record;
                this.addEditModalShow = true;
            },
            handleUpdatePwd(record) {
                this.fromData2.realname = record.realname;
                this.fromData2.username = record.username;
                this.fromData2.userId = record.id;
                this.fromData2.password = '';
                this.fromData2.password2 = '';
                this.pwdModalShow = true;
            },
            handleChangePwd() {
                if(!(this.fromData2.username || this.fromData2.username.length >= 6)) {
                  this.$message({
                    showClose: true,
                    message: '登录账号不能少于6位字符',
                    type: 'error'
                  });
                  return;
                }else if(this.fromData2.password != this.fromData2.password2){
                    this.$message({
                        showClose: true,
                        message: '两次密码不一致',
                        type:'error'
                    });
                    return;
                }else if(!(this.fromData2.password || this.fromData2.password.length >= 6)){
                    this.$message({
                        showClose: true,
                        message: '请输入正确的新密码，6~25位字符',
                        type:'error'
                    });
                    return;
                }else{
                    this.$http.post("/ea/sys/user/modifyPassword",this.fromData2).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '修改密码成功',
                                type:'success'
                            });
                            this.pwdModalShow = false;
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }
            },
            handleDelete(record) {
                this.$confirm('确定删除该成员吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post("/ea/sys/user/delete",{id:record.id}).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '删除成功',
                                type:'success'
                            });
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleOk() {
              this.$refs['fromData'].validate((valid) => {
                if (valid) {
                  this.submitFromData()
                  }
              });
            },
            submitFromData() {
              if(this.editData.id){
                this.$http.post("/ea/sys/user/edit",this.fromData).then((res) => {
                    let data = res.data;
                    if(data && data.code == 0 || data.code == 200){
                        this.$message({
                            message: '编辑成功',
                            type:'success'
                        });
                        this.addEditModalShow = false;
                        this.initData();
                    }else {
                        this.$message({
                            showClose: true,
                            message: data.message,
                            type:'error'
                        });
                    }
                })
              }else {
                  this.$http.post("/ea/sys/user/add",this.fromData).then((res) => {
                    let data = res.data;
                    if(data && data.code == 0 || data.code == 200){
                      this.$message({
                        message: '添加成功',
                        type:'success'
                      });
                      this.addEditModalShow = false;
                      this.initData();
                    }else {
                      this.$message({
                        showClose: true,
                        message: data.message,
                        type:'error'
                      });
                    }
                  })
              }
            }
        }
    }
</script>

<style lang="less" scoped>
    .tips {
        color: #666666;
        font-size: 12px;
        margin-left: 22px;
        .icons {
            font-size: 14px;
            color: #666666;
        }
    }
</style>
